import styled from "styled-components/macro";

export const FullBleed = styled.div`
  grid-column: 1 / -1;
`;
